module.exports = __webpack_public_path__ + "img/(1) - Pericuinkle.aa083164.png";